<template>
  <div>
    <a-form-model :model="countData" :rules="rules" ref="ruleForm">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="19">
            <div class="form_item" style="justify-content: flex-start">
              <label>保险期间</label>
              <div class="pre-box" style="margin-left: 10px">
                <div class="">
                  1年
                </div>
              </div>
            </div>
            <div class="order">
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)"
                >职业类别表</a
              >
            </div>
            <div class="form_item" style="justify-content: flex-start">
              <label>投保人数</label>
              <div class="right_">
                <div
                  class="check_item s_input"
                >
                  <a-input-number
                    :min="0"
                    :disabled="disabledAll"
                    v-model="personNum"
                    @change="(value) => changeData(value, 'TBZYa')"
                  ></a-input-number>
                  <span>人</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ order">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <div>
          <div class="form_item">
            <label class="item-label">意外身故及伤残保障</label>
            <div class="right_" style="margin-top: 4px">
              <a-input
                :disabled="true"
                style="width: 300px"
                :value="countData.YWSGSC | million"
                placeholder="请直接选择保障方案"
              ></a-input>
            </div>
          </div>
          <div class="form_item">
            <label class="item-label">客运民航客机意外身故残疾</label>
            <div class="right_" style="margin-top: 4px">
              <a-input
                :disabled="true"
                style="width: 300px"
                :value="countData.FJSG | million"
                placeholder="请直接选择保障方案"
              ></a-input>
            </div>
          </div>
          <div class="form_item">
            <label class="item-label">客运轨道交通意外身故残疾</label>
            <div class="right_" style="margin-top: 4px">
              <a-input
                :disabled="true"
                style="width: 300px"
                :value="countData.HCSG | million"
                placeholder="请直接选择保障方案"
              ></a-input>
            </div>
          </div>
          <div class="form_item">
            <label class="item-label">意外医药补偿</label>
            <div class="right_" style="margin-top: 10px">
              <a-input
                :disabled="true"
                style="width: 300px"
                :value="countData.YWYYBT | million"
                placeholder="请直接选择保障方案"
              ></a-input>
            </div>
          </div>
          <div class="form_item">
            <label class="item-label">猝死</label>
            <div class="right_" style="margin-top: 10px">
              <a-input
                :disabled="true"
                style="width: 300px"
                :value="countData.CS | million"
                placeholder="请直接选择保障方案"
              ></a-input>
            </div>
          </div>
          <div class="form_item">
            <label class="item-label">意外每日住院津贴</label>
            <div class="right_">
              <a-select
                :disabled="true"
                placeholder="请直接选择保障方案"
                style="width: 300px"
                class="select_"
                v-model="countData.YWMRJT"
              >
                <a-select-option
                  v-for="(item, index) in YWZYJTOptions"
                  :key="item.value + 'YWMRJT' + index"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <a-button
            class="calBtn_"
            :disabled="disabledAll"
            type="primary"
            @click="countPremiumSum()"
            >刷新试算</a-button
          >
        </div>
      </div>
    </a-form-model>
  </div>
</template>

<script>
let DATA = require("../data").default;
export default {
  data() {
    return {
      rules: {
        planSelect: [{ required: true, message: "请选择", trigger: "change" }],
      },
      productCode: "",
      plan: "",
      guapre: "1",
      //保障期间
      guarantPre: DATA.guarantPre,
      premiumSum: 0, //总保费
      // 保障方案选择
      // 扩展残疾鉴定国家工伤标准
      KZSCOptions: DATA.KZSCOptions,
      YWZYJTOptions: DATA.YWZYJTOptions,
      YWZBOptions: DATA.YWZBOptions,
      // 测算要提交的数据
      countData: DATA.countData,
      //提交data
      data: {
        riskInfos: [],
        salPolicy: {
          productCode: "", //产品code
          bracket: "1", //保费期限
          planCode: "",
        },
        salPolicyExt: {
          isworkheightinvolved: 2,
        },
        salPolicyHolder: {
          addfifty: "1", // 测算类型
          stature: 2, //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [], //人数
      },
      personNum: '', // 投保人数
      planType: "A",
    };
  },
  filters: {
    million: (value) => {
      let num;
      if (value > 9999) {
        num = Math.floor(value / 1000) / 10 + "万";
      } else if (value < 9999 && value > -9999) {
        num = value;
      } else if (value < -9999) {
        //小于-9999显示-x.xx万
        num = -(Math.floor(Math.abs(value) / 1000) / 10) + "万";
      }
      return num;
    },
  },
  computed: {
    fileCodeContent() {
      return this.$store.state.filecode.fileCodeContent;
    },
    // 是否阅读过
    agreementRead() {
      return this.$store.state.filecode.agreementRead;
    },
  },
  watch: {},
  props: ["disabledAll"],
  created() {
    const { p, planCode } = this.$route.query;
    this.productCode = p;
    this.plan = planCode;
    this.countPremiumSum("init");
  },
  mounted() {
    this.$bus.$on("busRiskInfos", () => {
      let obj = this.$lodash.cloneDeep(this.countData);
      // 回显传值的问题
      this.countData = { ...obj };
    });
  },
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit("setAgreement", true);
    },
    // 改变试算的数据
    changeData(value, param) {
      this.countData[param] = value;
    },
    //保费试算
    countPremiumSum(type) {
      console.log(type);
      console.log(this.countData);
      if (type == "init") {
        return;
      }
      if (!this.personNum) {
        this.$message.warning("请先选择投保人");
        return;
      }
      if (this.personNum < 3) {
        this.$message.warning("投保人数不能少于3人");
        return;
      }
      if (this.personNum > 200) {
        this.$message.warning("单张保单最高投保人数最多200人");
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.premiumSum = Number(this.countData.BF * this.personNum).toFixed(2);
        }
      });
    },
  },
  beforeDestroy() {
    this.$bus.$off("busRiskInfos");
  },
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
.waring-color {
  font-size: 12px;
  color: #e6a23c;
}
.gsdiposition {
  width: 300px;
}
.gsdc-icon {
  margin: 3px 3px 0;
}

.zuxianclass {
  margin-bottom: 6px;
  width: 690px;
  display: flex;
  margin-top: 6px;
}
.item-label {
  margin-top: 5px !important;
}
</style>